import { Route } from "react-router";
import UserManagement from "../components/pages/UserManagement";
import AddEditViewUser from "../components/pages/usermanagement/AddEditViewUser";
import ViewUsers from "../components/pages/usermanagement/ViewUsers";

const AdminRoutes = (
  <>
    <Route
      data-testid="userMngtRoute"
      path="/userManagement"
      element={<UserManagement />}
    />
    <Route
      index
      data-testid="addUserRoute"
      path="/user/add"
      element={<AddEditViewUser mode="ADD" />}
    />
    <Route
      index
      data-testid="editUserRoute"
      path="/user/:id/edit"
      element={<AddEditViewUser mode="EDIT" />}
    />
    <Route
      index
      data-testid="viewUserRoute"
      path="/user/:id/view"
      element={<AddEditViewUser mode="VIEW" />}
    />
    <Route
      index
      data-testid="viewUserRoute"
      path="/users/all"
      element={<ViewUsers />}
    />
  </>
);

export default AdminRoutes;
